export const globalHalfEdgeInfo = {
    counter: 0,
};
//# sourceMappingURL=globalHalfEdgeInfo.js.map